	<div class="p-2 -mb-3 {{view}}" (mouseenter)="hoveredItem = true" (mouseleave)="hoveredItem = false; op.hide()" [ngClass]="{'flex justify-content-between':view == 'listView'}" *ngIf="game.ItemType == '0';else offerTemplate">
		<div class="relative " [ngClass]="{'hovered': hoveredItem}">
			
			<img class="logo-editor shadow-5 transition-all transition-duration-300" src="https://blackrockgames.fr/upload/editor/350_{{game.logo_editor}}" style="">
			<div [routerLink]="['/game/'+game.Id]" class="fadein bg-black-alpha-50 absolute left-0 top-0 w-full h-full cursor-pointer" *ngIf="hoveredItem">
			</div>
			<div class="img" [style.backgroundImage]="'url(https://cdn.blackrockgames.fr/items/'+game.Id+'/couverture.png?width=600)'">
				<!-- <img loading="lazy" src="https://blackrockgames.fr/upload/cache/{{game.image_princ}}w480h320.jpeg" /> -->
			</div>
			<div [routerLink]="['/game/'+game.Id]" class="cursor-pointer text-center absolute w-full left-0 top-50 bg-black-alpha-70 capitalize" *ngIf="today < game.out_date_date && !game.rupture">
				Disponible {{game.out_date_date | date:'dd MMMM YYYY'}}
			</div>
			<div class="absolute text-center top-0 left-0 w-full pt-8 flex flex-column align-items-center" *ngIf="game.rupture && api.pro">
				<div class="rupture-badge mb-2">
					<!-- <i class="pi pi-exclamation-triangle" *ngIf="game.Id != 'CAT100FL'"></i>
					<span class="rupture-text">{{game.Id == 'CAT100FL' ? 'Contactez votre commercial' : 'Rupture de stock'}}</span> -->
					<i class="pi pi-exclamation-triangle" ></i>
					<span class="rupture-text">Rupture de stock</span>
				</div>
				<div class="bg-black-alpha-90 py-2 px-3 border-round-sm mt-2 mx-2" *ngIf="api.reassorts && !api.reassorts[game.Id]">
					<p-checkbox [(ngModel)]="game.reassort_suscribed" [binary]="true" label="Être informé du réassort." (onChange)="subscribeToReassort($event)"></p-checkbox>
				</div>
				<div class="bg-primary py-2 px-3 border-round-sm mt-2 mx-2 text-white font-semibold" *ngIf="api.reassorts && api.reassorts[game.Id]">
					<i class="pi pi-calendar mr-2"></i>
					<span>Réassort {{api.reassorts[game.Id].date | date:'MMMM YYYY'}}</span>
					<!-- <span *ngIf="game.Id == 'CAT080CO'">Contactez votre commercial</span> -->
				</div>
			</div>
			<!-- <div class="text-center text-700 font-medium text-xl mb-3 fadein transition-duration-300" *ngIf="hoveredItem">{{game.name_editor}}</div> -->

			<button pButton (click)="setFavorite()" icon="pi {{isFav() ? 'pi-heart-fill' : 'pi-heart'}}" pRipple class="fadein p-button-rounded absolute p-button-outlined " style="top:10px;right: 10px;" *ngIf="api.user">
			</button>
			<div class="flex justify-content-end absolute w-full z-2 transition-all transition-duration-300" [ngClass]="{'opacity-0':hoveredItem}" style="bottom:-20px" *ngIf="game.awards != null && game.awards.length > 0">
				<img  class="" src="/assets/award.svg" width="80" />
			</div>
		</div>
		<div class="surface-card pt-3 z-1 relative transition-all transition-duration-300 data relative border-round-sm " 
		[ngClass]="{'-mt-8 pb-8': hoveredItem && view == 'gridView','flex flex-column justify-content-between':view == 'listView'}">
		<div class="text-center text-900 mb-3 uppercase w-full">
			{{game.name}}
		</div>
		<div class="flex align-items-center justify-content-around " *ngIf="api.user">
			<div class="text-center text-200 font-medium text-xl mb-3 relative" >
				<span class="">{{game.priceHT | currency:'EUR'}}</span>
				<span class="text-xs absolute left-0" style="top:-10px"> Brut HT</span>
			</div>
			<div class="text-center text-800 font-medium text-xl mb-3 relative">
				{{game.priceHT - (game.priceHT * game.discountRate/100) | currency:'EUR'}}
				<span class="text-xs absolute left-0" style="top:-10px">Net HT</span>
			</div>
		</div>
		<div class="border-round-sm flex align-items-center transition-all transition-duration-300 justify-content-around" [ngClass]="{'opacity-0': !hoveredItem && view == 'gridView'}" >
			<i *ngIf="api.pro && game.orderable " class="pi pi-shopping-cart cursor-pointer" style="font-size: 2rem" (click)="api.selectedProduct = game;api.dialogOffers = true;"></i>
			<i *ngIf="api.user" class="pi pi-info-circle cursor-pointer" pBadge style="font-size: 2rem" value="{{game.alreadyOrdered}}" (click)="op.toggle($event)"></i>
			<i [routerLink]="['/game/'+game.Id]" class="pi pi-eye cursor-pointer" style="font-size: 2rem" ></i>
		</div>
	</div>
</div>

<p-overlayPanel #op>
	<ng-template pTemplate>
		<div *ngIf="game.alreadyOrdered > 0">Vous avez commandé {{game.alreadyOrdered}} exemplaire(s)</div>
		<div *ngIf="game.alreadyOrdered === 0">Vou n'avez jamais commandé cet article</div>
	</ng-template>
</p-overlayPanel>

<ng-template #offerTemplate>
	<div class="p-2 -mb-3 {{view}}" (mouseenter)="hoveredItem = true" (mouseleave)="hoveredItem = false; op.hide()" [ngClass]="{'flex justify-content-between':view == 'listView'}">
		<div class="relative " [ngClass]="{'hovered': hoveredItem}" (click)="imgDialog = true">
			
			<img class="logo-editor shadow-5 transition-all transition-duration-300" src="https://blackrockgames.fr/upload/editor/350_{{game.logo_editor}}" style="">
			<div class="fadein bg-black-alpha-50 absolute left-0 top-0 w-full h-full cursor-pointer" *ngIf="hoveredItem">
			</div>
			<div class="img" [style.backgroundImage]="'url(https://blackrockgames.fr/upload/thumbd.php?id='+game.image_princ+'&id_item='+game.id_item+'&size=w640h480)'">
				<!-- <img loading="lazy" src="https://blackrockgames.fr/upload/cache/{{game.image_princ}}w480h320.jpeg" /> -->
			</div>
		</div>
		<div class="surface-card pt-3 z-1 relative transition-all transition-duration-300 data relative border-round-sm " 
		[ngClass]="{'-mt-8 pb-8': hoveredItem && view == 'gridView','flex flex-column justify-content-between':view == 'listView'}">
		<div class="text-center text-900 mb-3 uppercase">
			{{game.name}}
		</div>
		<div class="border-round-sm flex align-items-center transition-all transition-duration-300 justify-content-around" [ngClass]="{'opacity-0': !hoveredItem && view == 'gridView'}" >
			<i *ngIf="api.pro && game.orderable" class="pi pi-shopping-cart cursor-pointer" style="font-size: 2rem" (click)="addOffer(game.Id)"></i>
			<i class="pi pi-eye cursor-pointer" style="font-size: 2rem" (click)="imgDialog = true"></i>
		</div>
	</div>
</div>
<p-dialog [(visible)]="imgDialog" [modal]="true" [dismissableMask]="true" [header]="game.name" (onShow)="imgDialogShow($event)" contentStyleClass="imgDialogContent">
	<img src="/assets/offres/{{game.Id}}.jpg" style="opacity: 0;" (error)="game.imgError = true" (load)="game.imgError = false;"/>
	<ng-template pTemplate="footer">
		<button pButton pRipple (click)="imgDialog = false;" label="Annuler" class="p-button-outlined p-button-danger"></button>
		<button *ngIf="api.pro && game.orderable"  pButton pRipple (click)="addOffer(game.Id);imgDialog = false" label="En profiter" class=""></button>
	</ng-template>
</p-dialog>
</ng-template>